import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import { Column, Columns } from "@seneca/senekit";

import {
  optimisticallyUpdateAttributes,
  setAccountTypeToSchoolTeacher
} from "features/user";
import { userAccountType } from "features/user/consts";

import SignUpWithProgressBarWrapper from "../../../components/SignUpWithProgressBarWrapper";
import AccountTypeButton, { accountTypeBtn } from "./AccountTypeButton";

const SUBMIT_DELAY = 500;

export type Props = {
  onStudentClick: () => void;
  onTeacherClick: () => void;
  onParentClick: () => void;
  pageNumber: number;
  totalNumberOfPages: number;
};

export default function SignUpFormAccountType({
  onStudentClick,
  onTeacherClick,
  onParentClick,
  pageNumber,
  totalNumberOfPages
}: Props) {
  const [selected, setSelected] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout>();
  const dispatch = useDispatch();

  useEffect(() => {
    // @ts-ignore
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const handleStudentClick = () => {
    setSelected(accountTypeBtn.student.displayName);
    timeoutRef.current = setTimeout(onStudentClick, SUBMIT_DELAY);
  };

  const handleTeacherClick = () => {
    setSelected(accountTypeBtn.teacher.displayName);
    dispatch(setAccountTypeToSchoolTeacher());
    timeoutRef.current = setTimeout(onTeacherClick, SUBMIT_DELAY);
  };

  const handleParentClick = () => {
    setSelected(accountTypeBtn.parent.displayName);
    timeoutRef.current = setTimeout(async () => {
      const userDetails = {
        type: userAccountType.schoolparent
      };
      const output = await dispatch(
        optimisticallyUpdateAttributes(userDetails as any)
      );

      if (!(output instanceof Error)) {
        onParentClick();
      }
    }, SUBMIT_DELAY);
  };

  const teacherSelected = selected === accountTypeBtn.teacher.displayName;
  const parentSelected = selected === accountTypeBtn.parent.displayName;
  const studentSelected = selected === accountTypeBtn.student.displayName;

  return (
    <SignUpWithProgressBarWrapper
      header="Tell us about yourself"
      pageNumber={pageNumber}
      totalNumberOfPages={totalNumberOfPages}
    >
      <Columns collapseBelow="tablet" space="large">
        <Column>
          <AccountTypeButton
            accountType={accountTypeBtn.student.displayName as any}
            selected={studentSelected}
            onClick={selected ? undefined : handleStudentClick}
          />
        </Column>
        <Column>
          <AccountTypeButton
            accountType={accountTypeBtn.teacher.displayName as any}
            selected={teacherSelected}
            onClick={selected ? undefined : handleTeacherClick}
          />
        </Column>
        <Column>
          <AccountTypeButton
            accountType={accountTypeBtn.parent.displayName as any}
            selected={parentSelected}
            onClick={selected ? undefined : handleParentClick}
          />
        </Column>
      </Columns>
    </SignUpWithProgressBarWrapper>
  );
}
